"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var i18next_1 = __importDefault(require("i18next"));

var hooks_1 = require("preact/hooks");

var preact_1 = require("preact");

var config_1 = require("../constants/config");

function Login() {
  var loginUrl = hooks_1.useMemo(function () {
    return "".concat(config_1.LOGIN_URL, "/afreeca/login.php?szFrom=full&request_uri=").concat(encodeURIComponent(location.href));
  }, []);
  var loginText = hooks_1.useMemo(function () {
    return i18next_1.default.t("<em onclick={{handleGoLogin}}>\uB85C\uADF8\uC778</em>\uD558\uC2DC\uBA74<br />\uC88B\uC544\uD558\uC2DC\uB294 BJ\uC640 \uBC29\uC1A1\uC758<br />\uC0C8\uB85C\uC6B4 \uC18C\uC2DD\uC744 \uC54C\uB824\uB4DC\uB9BD\uB2C8\uB2E4.", {
      handleGoLogin: "document.location.href='".concat(loginUrl, "'")
    });
  }, []);
  return preact_1.h("div", {
    id: "NotLogin",
    className: "serviceLogin"
  }, preact_1.h("div", {
    className: "inner"
  }, preact_1.h("div", {
    className: "text",
    dangerouslySetInnerHTML: {
      __html: loginText
    }
  })));
}

exports.default = Login;